import { render, staticRenderFns } from "./LoginFormFinal.vue?vue&type=template&id=483d8c64&scoped=true&"
import script from "./LoginFormFinal.vue?vue&type=script&lang=js&"
export * from "./LoginFormFinal.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormFinal.vue?vue&type=style&index=0&id=483d8c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d8c64",
  null
  
)

export default component.exports